import React from "react";
import "../styles/about.css";
import ME from '../images/me.JPG';

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about_container">
        <div className="about_me">
          <div className="about_me_img">
            <img alt='my pic' src={ME} />
          </div>
        </div>

        <div className="about_content">
          <h1>Senior Systems Engineer <span> - Infosys Ltd</span></h1>
          <h4>2+ years of working experience</h4>
          <p>
          <li>Planned website development & Coded websites, components
using HTML, CSS, SASS, JavaScript, React JS, JQuery languages.</li>
<li>Worked on website maintenance, content management.</li>
          </p>
          <a href="#contact" className="btn btn-primary">Let's Talk </a>
        </div>

      </div>
    </section>
  );
};

export default About;
